import Box, { type BoxProps } from '@mui/material/Box'
import TableCell from '@mui/material/TableCell'
import TableRow, { type TableRowProps } from '@mui/material/TableRow'
import { type PropsWithChildren } from 'react'

const Center = (props: PropsWithChildren<BoxProps>) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    position="absolute"
    left={0}
    right={0}
    top={0}
    bottom={0}
    borderBottom="1px solid"
    borderColor="divider"
    {...props}
  />
)

export interface TableRowWithCenterElementWpProps extends TableRowProps {
  rowSize: number
}

export const TableRowWithCenterElementWp = (props: TableRowWithCenterElementWpProps) => {
  const { rowSize, className, children, ...rest } = props
  return new Array(rowSize).fill(0).map((_, i) => (
    <TableRow key={i} className={className} {...rest}>
      {i === rowSize - 1
        ? (
          <TableCell sx={{ border: 'none' }}>
            <Center>{children}</Center>
          </TableCell>
        )
        : <TableCell sx={{ border: 'none' }} />}
    </TableRow>
  ))
}
